import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["target", "template"];
  static values = {
    wrapperSelector: {
      type: String,
      default: ".nested-form-wrapper",
    },
    childIndex: {
      type: String,
      default: "NEW_RECORD",
    },
  };

  add(e) {
    e.preventDefault();

    const regexp = new RegExp(this.childIndexValue, "g");

    const content = this.templateTarget.innerHTML.replace(
      regexp,
      new Date().getTime().toString(),
    );
    this.targetTarget.insertAdjacentHTML("beforebegin", content);

    const event = new CustomEvent("rails-nested-form:add", { bubbles: true });
    this.element.dispatchEvent(event);
  }

  remove(e) {
    e.preventDefault();

    // @ts-expect-error
    const wrapper = e.target.closest(this.wrapperSelectorValue);

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove();
    } else {
      wrapper.style.display = "none";

      const input = wrapper.querySelector("input[name*='_destroy']");
      input.value = "1";
    }

    const event = new CustomEvent("rails-nested-form:remove", {
      bubbles: true,
    });
    this.element.dispatchEvent(event);
  }
}
